
(function() {
  var result = { translations: { "en": { "foundations-components": { "ActionsMenu": { "defaultAriaLabel": "Actions" }, "tag": { "remove": "Remove tag" }, "Select": { "noResults": "No results found", "searchPlaceholder": "Search...", "clearSelections": "Clear selections" }, "ErrorMessage": { "error": { "title": "All is not lost." }, "notFound": { "title": "All who wander are not lost." }, "badRequest": { "title": "There was a problem loading this page." }, "expired": { "title": "We're sorry." }, "sessionId": { "prefix": "Session Id: " } }, "ProgressSteps": { "completedStep": "Completed step", "incompleteStep": "Incomplete step" }, "Paginator": { "label": "Pagination", "pageNumber": { "currentIndicator": "You are currently on ", "description": "Page " }, "firstPage": { "label": "First", "description": "First page" }, "previousPage": { "label": "Prev", "description": "Previous page" }, "nextPage": { "label": "Next", "description": "Next page" }, "lastPage": { "label": "Last", "description": "Last page" } }, "Datagrid": { "noData": { "Title": "No data available", "Description": "There is no data available to display." }, "noResults": { "Title": "No results found", "Description": "Try adjusting your search and filters to find what you're looking for.", "ClearActionLabel": "Clear search and filters" }, "toolbar": { "selectedRows": { "one": "{{count}} row selected", "other": "{{count}} rows selected", "clearSelection": "Clear selection", "selectAll": "Select all {{totalRows}} rows" }, "search": { "placeholder": "Search", "label": "Search", "clearSearch": "Clear search" } }, "pagination": { "visibleRows": "{{visibleRows}} of {{totalRows}} results", "itemsPerPage": "Items per page", "countPerPage": { "one": "{{count}} per page", "other": "{{count}} per page" } }, "SkeletonGrid": { "loading": "Loading" }, "DataGridColumnManagementPanel": { "description": "Choose which properties to display as columns. Then, move properties up or down, or drag and drop, to change the order they will be displayed.", "removeAllColumns": "Remove all columns", "update": "Update", "cancel": "Cancel", "edit": "Edit columns" } } }, "ui": { "UIAbstractPageSection": { "page": "Page Section" }, "UICarousel": { "current": "Showing item {{currentStepDisplayNumber}} out of {{totalSteps}}", "prev": "Previous", "next": "Next", "tip": "Use arrow keys to see other items" }, "UIColorSwatch": { "label": "Color picker {{value}}", "noColorLabel": "Color picker, no color selected." }, "UIButtonCollapser": { "dropdownLabel": "Actions" }, "UIErrorMessage": { "error": { "title": "All is not lost." }, "notFound": { "title": "All who wander are not lost." }, "badRequest": { "title": "There was a problem loading this page." }, "expired": { "title": "We're sorry." } }, "UIPanelNavigator": { "backButton": "Go to previous screen" }, "UILoadingSpinner": { "busyText": "Loading", "completedText": "Loaded" }, "UISideNav": { "navigationLandmark": "Secondary" }, "UISortTH": { "ascendingSort": "Ascending sort. Press to sort descending.", "descendingSort": "Descending sort. Press to sort ascending.", "pressToSort": "Press to sort." }, "autosizedTextInput": { "charactersRemaining": "{{value}} characters remaining" }, "time": { "today": "Today at {{time}}", "yesterday": "Yesterday at {{time}}", "datetime": "{{date}} at {{time}}" }, "progress": { "percentComplete": "{{percent}} complete" }, "datePicker": { "dateSelected": "{{date}} is selected.", "noDateSelected": "No date selected.", "dateBelowMin": "You must choose a newer date", "dateAboveMax": "You must choose an older date", "invalidDate": "Invalid date", "today": "Today", "clear": "Clear", "placeholder": { "month": "MM", "day": "DD", "year": "YYYY" }, "nextMonth": "Next month", "prevMonth": "Previous month" }, "dateRange": { "startDate": "Start date", "endDate": "End date", "endDateBeforeStartDate": "The end date must come after the start date.", "startDateAfterEndDate": "The start date must come before the end date.", "to": "to" }, "timePicker": { "placeholder": { "hour": "HH", "minute": "MM" } }, "SelectResultList": { "andMore": "\u2026and {{count}} more.", "loadMore": "Load more" } }, "salesUI": { "UIAvatarAdd": { "ariaLabel": "Add" }, "UIAvatarHoverlay": { "text": "Change photo" }, "UIChangeArrow": { "decrease": "Decrease of ", "increase": "Increase of " }, "UICopyInput": { "label": "Copy", "title": "Copy to clipboard", "tooltipCopied": "Copied" }, "UIConfirm": { "defaultConfirm": "Yes", "defaultReject": "No" }, "UICloseButton": { "label": "Close" }, "UIDateRangePicker": { "rangeType": { "ALL": "All time", "THIS_DAY": "Today", "LAST_DAY": "Yesterday", "THIS_WEEK": "This week", "LAST_WEEK": "Last week", "THIS_MONTH": "This month", "LAST_MONTH": "Last month", "LAST_THIRTY_DAYS": "Last 30 days", "LAST_THREE_MONTHS": "Last 3 months", "THIS_QUARTER": "This quarter", "LAST_QUARTER": "Last quarter", "THIS_YEAR": "This year", "LAST_YEAR": "Last year", "CUSTOM": "Custom time period" } }, "UIDropdownSelect": { "placeholder": "No value selected" }, "UIEditableControls": { "cancel": "Cancel", "save": "Save" }, "UIExpandableText": { "collapseButtonText": "See less", "expandButtonText": "See more" }, "UIFileInput": { "defaultChangeLabel": "Change file", "defaultSelectLabel": "Choose file" }, "UIIconRating": { "ariaValueText": "{{value}} of {{maxValue}}" }, "UILink": { "externalTitle": "Link opens in a new window" }, "UILoading": { "title": "Loading\u2026" }, "UILockBadge": { "title": "This feature is locked" }, "UIPaginator": { "label": "Pagination", "pageNumber": { "currentIndicator": "You are currently on ", "description": "Page " }, "firstPage": { "label": "First", "description": "First page" }, "previousPage": { "label": "Prev", "description": "Previous page" }, "nextPage": { "label": "Next", "description": "Next page" }, "lastPage": { "label": "Last", "description": "Last page" } }, "UIPreviousButton": { "label": "Previous" }, "UINextButton": { "label": "Next" }, "UINumberRating": { "lowRangeLabel": "Strongly disagree", "highRangeLabel": "Strongly agree" }, "UISearchableSelectInput": { "placeholder": "Search" }, "UISearchInput": { "placeholder": "Search", "minimumSearchMessage": { "one": "Type 1 more character", "other": "Type {{count}} more characters" }, "clearButton": "Clear input" }, "UISelect": { "allOptionsSelected": "All options are selected", "createOption": "Create option \u201C{{label}}\u201D", "plusMore": "+ {{count}} more", "andMore": "\u2026and {{count}} more.", "loadMore": "Load more", "noResults": "No results found", "placeholder": "Search", "typeToSearch": "Type to search" }, "UITable": { "selectableTableRow": { "toggleSelection": "Toggle selection of the row" } }, "UITabs": { "moreDropdownLabel": "More" }, "UITeaseNotification": { "optionsButtonTooltipText": "Show options" }, "UITimePicker": { "placeholder": "Select a time" }, "UIToggle": { "checkedLabel": "ON", "uncheckedLabel": "OFF" }, "UITypeahead": { "noMatchesFound": "No matches found", "noOptions": "None" }, "UIWizard": { "back": "Back", "cancel": "Cancel", "done": "Done", "next": "Next", "stepCount": "Step {{stepNumber}} of {{stepCount}}" }, "XSSTooltip": { "explanation": "This link has been disabled for your security." } } } } };
  result.translationsLoaded = {
  "foundations-components": {
    "en": "static-1.4933"
  }
};
  result.translationsAvailable = {
  "foundations-components": {
    "af": "static-1.4933",
    "ar-eg": "static-1.4933",
    "bg": "static-1.4933",
    "bn": "static-1.4933",
    "ca-es": "static-1.4933",
    "cs": "static-1.4933",
    "da": "static-1.4933",
    "de": "static-1.4933",
    "el": "static-1.4933",
    "en-gb": "static-1.4933",
    "en": "static-1.4933",
    "es-mx": "static-1.4933",
    "es": "static-1.4933",
    "et": "static-1.4933",
    "fi": "static-1.4933",
    "fr-ca": "static-1.4933",
    "fr": "static-1.4933",
    "he-il": "static-1.4933",
    "hi": "static-1.4933",
    "hr": "static-1.4933",
    "hu": "static-1.4933",
    "id": "static-1.4933",
    "it": "static-1.4933",
    "ja": "static-1.4933",
    "ko": "static-1.4933",
    "lt": "static-1.4933",
    "ms": "static-1.4933",
    "nl": "static-1.4933",
    "no": "static-1.4933",
    "pl": "static-1.4933",
    "pt-br": "static-1.4933",
    "pt-pt": "static-1.4933",
    "ro": "static-1.4933",
    "ru": "static-1.4933",
    "sk": "static-1.4933",
    "sl": "static-1.4933",
    "sv": "static-1.4933",
    "th": "static-1.4933",
    "tl": "static-1.4933",
    "tr": "static-1.4933",
    "uk": "static-1.4933",
    "vi": "static-1.4933",
    "zh-cn": "static-1.4933",
    "zh-hk": "static-1.4933",
    "zh-tw": "static-1.4933"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:foundations-components:en', {version: 'static-1.4933'}); }
})();



(function() {
  var result = { translations: { "en": { "placeholder": "placeholder" } } };
  result.translationsLoaded = {
  "UIComponents": {
    "en": "static-3.6438"
  }
};
  result.translationsAvailable = {
  "UIComponents": {
    "af": "static-3.6438",
    "ar-eg": "static-3.6438",
    "bg": "static-3.6438",
    "bn": "static-3.6438",
    "ca-es": "static-3.6438",
    "cs": "static-3.6438",
    "da": "static-3.6438",
    "de": "static-3.6438",
    "el": "static-3.6438",
    "en-gb": "static-3.6438",
    "en": "static-3.6438",
    "es-mx": "static-3.6438",
    "es": "static-3.6438",
    "et": "static-3.6438",
    "fi": "static-3.6438",
    "fr-ca": "static-3.6438",
    "fr": "static-3.6438",
    "he-il": "static-3.6438",
    "hi": "static-3.6438",
    "hr": "static-3.6438",
    "hu": "static-3.6438",
    "id": "static-3.6438",
    "it": "static-3.6438",
    "ja": "static-3.6438",
    "ko": "static-3.6438",
    "lt": "static-3.6438",
    "ms": "static-3.6438",
    "nl": "static-3.6438",
    "no": "static-3.6438",
    "pl": "static-3.6438",
    "pt-br": "static-3.6438",
    "pt-pt": "static-3.6438",
    "ro": "static-3.6438",
    "ru": "static-3.6438",
    "sk": "static-3.6438",
    "sl": "static-3.6438",
    "sv": "static-3.6438",
    "th": "static-3.6438",
    "tl": "static-3.6438",
    "tr": "static-3.6438",
    "uk": "static-3.6438",
    "vi": "static-3.6438",
    "zh-cn": "static-3.6438",
    "zh-hk": "static-3.6438",
    "zh-tw": "static-3.6438"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:UIComponents:en', {version: 'static-3.6438'}); }
})();



(function() {
  var result = { translations: { "en": { "validatedFormControl": { "validationMessageDefaults": { "input": { "validating": "Validating input...", "success": "That input is valid.", "error": "That input isn't valid." }, "email": { "validating": "Validating email address...", "success": "That email address is valid.", "error": "That email address isn't valid." }, "password": { "validating": "Validating password...", "success": "Perfect. The password you entered meets our requirements.", "error": "Sorry. The password you entered does not meet our requirements." }, "url": { "validating": "Validating URL...", "success": "That URL is valid.", "error": "That URL isn't valid." } } } } } };
  result.translationsLoaded = {
  "ui-addon-form-validation": {
    "en": "static-1.9028"
  }
};
  result.translationsAvailable = {
  "ui-addon-form-validation": {
    "af": "static-1.9028",
    "ar-eg": "static-1.9028",
    "bg": "static-1.9028",
    "bn": "static-1.9028",
    "ca-es": "static-1.9028",
    "cs": "static-1.9028",
    "da": "static-1.9028",
    "de": "static-1.9028",
    "el": "static-1.9028",
    "en-gb": "static-1.9028",
    "en": "static-1.9028",
    "es-mx": "static-1.9028",
    "es": "static-1.9028",
    "et": "static-1.9028",
    "fi": "static-1.9028",
    "fr-ca": "static-1.9028",
    "fr": "static-1.9028",
    "he-il": "static-1.9028",
    "hi": "static-1.9028",
    "hr": "static-1.9028",
    "hu": "static-1.9028",
    "id": "static-1.9028",
    "it": "static-1.9028",
    "ja": "static-1.9028",
    "ko": "static-1.9028",
    "lt": "static-1.9028",
    "ms": "static-1.9028",
    "nl": "static-1.9028",
    "no": "static-1.9028",
    "pl": "static-1.9028",
    "pt-br": "static-1.9028",
    "pt-pt": "static-1.9028",
    "ro": "static-1.9028",
    "ru": "static-1.9028",
    "sk": "static-1.9028",
    "sl": "static-1.9028",
    "sv": "static-1.9028",
    "th": "static-1.9028",
    "tl": "static-1.9028",
    "tr": "static-1.9028",
    "uk": "static-1.9028",
    "vi": "static-1.9028",
    "zh-cn": "static-1.9028",
    "zh-hk": "static-1.9028",
    "zh-tw": "static-1.9028"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:ui-addon-form-validation:en', {version: 'static-1.9028'}); }
})();



(function() {
  var result = { translations: { "en": { "SharedLegalStrings": { "consent": { "communicationConsentText": "{{ companyName }} is committed to protecting and respecting your privacy, and we\u2019ll only use your personal information to administer your account and to provide the products and services you requested from us. From time to time, we would like to contact you about our products and services, as well as other content that may be of interest to you. If you consent to us contacting you for this purpose, please tick below to say how you would like us to contact you:", "communicationConsentCheckboxes": { "label": "I agree to receive other communications from {{ companyName }}." }, "implicitProcessingConsentText": "By clicking submit below, you consent to allow {{ companyName }} to store and process the personal information submitted above to provide you the content requested.", "explicitProcessingConsentText": "In order to provide you the content requested, we need to store and process your personal data. If you consent to us storing your personal data for this purpose, please tick the checkbox below.", "explicitProcessingConsentCheckboxLabel": "I agree to allow {{ companyName }} to store and process my personal data.", "privacyPolicyText": "You can unsubscribe from these communications at any time. For more information on how to unsubscribe, our privacy practices, and how we are committed to protecting and respecting your privacy, please review our Privacy Policy.", "legitimateInterestPrivacyPolicyText": "{{ companyName }} needs the contact information you provide to us to contact you about our products and services. You may unsubscribe from these communications at any time. For information on how to unsubscribe, as well as our privacy practices and commitment to protecting your privacy, please review our Privacy Policy." } } } } };
  result.translationsLoaded = {
  "SharedLegalStrings": {
    "en": "static-1.1255"
  }
};
  result.translationsAvailable = {
  "SharedLegalStrings": {
    "af": "static-1.1255",
    "ar-eg": "static-1.1255",
    "bg": "static-1.1255",
    "bn": "static-1.1255",
    "ca-es": "static-1.1255",
    "cs": "static-1.1255",
    "da": "static-1.1255",
    "de": "static-1.1255",
    "el": "static-1.1255",
    "en-gb": "static-1.1255",
    "en": "static-1.1255",
    "es-mx": "static-1.1255",
    "es": "static-1.1255",
    "et": "static-1.1255",
    "fi": "static-1.1255",
    "fr-ca": "static-1.1255",
    "fr": "static-1.1255",
    "he-il": "static-1.1255",
    "hi": "static-1.1255",
    "hr": "static-1.1255",
    "hu": "static-1.1255",
    "id": "static-1.1255",
    "it": "static-1.1255",
    "ja": "static-1.1255",
    "ko": "static-1.1255",
    "lt": "static-1.1255",
    "ms": "static-1.1255",
    "nl": "static-1.1255",
    "no": "static-1.1255",
    "pl": "static-1.1255",
    "pt-br": "static-1.1255",
    "pt-pt": "static-1.1255",
    "ro": "static-1.1255",
    "ru": "static-1.1255",
    "sk": "static-1.1255",
    "sl": "static-1.1255",
    "sv": "static-1.1255",
    "th": "static-1.1255",
    "tl": "static-1.1255",
    "tr": "static-1.1255",
    "uk": "static-1.1255",
    "vi": "static-1.1255",
    "zh-cn": "static-1.1255",
    "zh-hk": "static-1.1255",
    "zh-tw": "static-1.1255"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:SharedLegalStrings:en', {version: 'static-1.1255'}); }
})();



(function() {
  var result = { translations: { "en": { "sanitizedEmail": { "imageError": "This image is too large to display.", "expandEmailButtonText": "Expand", "collapseEmailButtonText": "Collapse", "hideEmailRepliesButtonText": "Hide trimmed content", "showEmailRepliesButtonText": "View trimmed content" } } } };
  result.translationsLoaded = {
  "sanitize-text": {
    "en": "static-1.6193"
  }
};
  result.translationsAvailable = {
  "sanitize-text": {
    "af": "static-1.6193",
    "ar-eg": "static-1.6193",
    "bg": "static-1.6193",
    "bn": "static-1.6193",
    "ca-es": "static-1.6193",
    "cs": "static-1.6193",
    "da": "static-1.6193",
    "de": "static-1.6193",
    "el": "static-1.6193",
    "en-gb": "static-1.6193",
    "en": "static-1.6193",
    "es-mx": "static-1.6193",
    "es": "static-1.6193",
    "et": "static-1.6193",
    "fi": "static-1.6193",
    "fr-ca": "static-1.6193",
    "fr": "static-1.6193",
    "he-il": "static-1.6193",
    "hi": "static-1.6193",
    "hr": "static-1.6193",
    "hu": "static-1.6193",
    "id": "static-1.6193",
    "it": "static-1.6193",
    "ja": "static-1.6193",
    "ko": "static-1.6193",
    "lt": "static-1.6193",
    "ms": "static-1.6193",
    "nl": "static-1.6193",
    "no": "static-1.6193",
    "pl": "static-1.6193",
    "pt-br": "static-1.6193",
    "pt-pt": "static-1.6193",
    "ro": "static-1.6193",
    "ru": "static-1.6193",
    "sk": "static-1.6193",
    "sl": "static-1.6193",
    "sv": "static-1.6193",
    "th": "static-1.6193",
    "tl": "static-1.6193",
    "tr": "static-1.6193",
    "uk": "static-1.6193",
    "vi": "static-1.6193",
    "zh-cn": "static-1.6193",
    "zh-hk": "static-1.6193",
    "zh-tw": "static-1.6193"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:sanitize-text:en', {version: 'static-1.6193'}); }
})();



(function() {
  var result = { translations: { "en": { "a11y": { "viewSpecificPage": "Now displaying page {{ pageNumber }}", "hiddenPDFControls": "Navigate between pages of this document", "previousPage": "Go to previous page", "nextPage": "Go to next page", "pageSelectorButton": "Page {{ pageNumber }}", "pageSelectorContainer": "Select a page", "senderProfile": "Book a meeting or send an email to {{ email }}", "downloadButton": "Download this document to your computer", "shareButton": "Access a shareable link for this document", "skipToDocument": "Skip links to display main content.", "brandingAltTextNoCompany": "Company logo", "brandingAltText": "{{ companyName }} logo" }, "app": { "htmlTitle": "Documents | HubSpot", "title": "Documents" }, "view": { "notAvailable": "This document is temporarily unavailable. Try again after {{ date }}.", "notFound": "But that page is nowhere to be found", "error": "Sorry, looks like the document you were looking for is unavailable.", "toolbar": { "download": "Download", "share": "Share", "shareThisLink": "Share this link", "sender": { "meetingsLink": "Let's meet", "emailLink": "Email me" }, "addLogo": "Add your logo" }, "viewerInfo": { "header": { "title": { "withName": "{{ name }} shared this document with you.", "noName": "Someone shared this document with you." }, "subtitle": "Please enter your email address to continue" }, "submit": "Submit" }, "previewAlert": { "title": "Preview - do not share this page", "description": "To send a tracked link, return to the {{ documentSummaryLink }}.", "documentSummaryLink": "document summary" }, "utm": { "shareYourFiles": "This document was shared using", "getHubSpotFree": "Try HubSpot for free" }, "gdprSubmissionError": { "title": "There was a problem submitting the form.", "message": "Please refresh the page and try again. If the problem persists, contact the document owner." } }, "pdf": { "error": { "errorTitle": "Well, this is disappointing", "errorDescription": "Sorry, looks like the document you were looking for is unavailable.", "tryAgain": "Refresh and try again" }, "controls": { "page": "Page {{ pageNumber }} of {{ totalPages }}" } } } } };
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "documents-lib": {
    "af": "static-1.26661",
    "ar-eg": "static-1.26661",
    "bg": "static-1.26661",
    "bn": "static-1.26661",
    "ca-es": "static-1.26661",
    "cs": "static-1.26661",
    "da": "static-1.26661",
    "de": "static-1.26661",
    "el": "static-1.26661",
    "en-gb": "static-1.26661",
    "en": "static-1.26661",
    "es-mx": "static-1.26661",
    "es": "static-1.26661",
    "et": "static-1.26661",
    "fi": "static-1.26661",
    "fr-ca": "static-1.26661",
    "fr": "static-1.26661",
    "he-il": "static-1.26661",
    "hi": "static-1.26661",
    "hr": "static-1.26661",
    "hu": "static-1.26661",
    "id": "static-1.26661",
    "it": "static-1.26661",
    "ja": "static-1.26661",
    "ko": "static-1.26661",
    "lt": "static-1.26661",
    "ms": "static-1.26661",
    "nl": "static-1.26661",
    "no": "static-1.26661",
    "pl": "static-1.26661",
    "pt-br": "static-1.26661",
    "pt-pt": "static-1.26661",
    "ro": "static-1.26661",
    "ru": "static-1.26661",
    "sk": "static-1.26661",
    "sl": "static-1.26661",
    "sv": "static-1.26661",
    "th": "static-1.26661",
    "tl": "static-1.26661",
    "tr": "static-1.26661",
    "uk": "static-1.26661",
    "vi": "static-1.26661",
    "zh-cn": "static-1.26661",
    "zh-hk": "static-1.26661",
    "zh-tw": "static-1.26661"
  }
};
  hns('I18n', result);

})();


